import * as types from "./solicitacao.actionTypes";

export default {
  setSolicitacao: data => ({
    type: types.SET_SOLICITACAO,
    payload: data
  }),
  setComboboxCCM: (itensCombobox, cnpjCpf) => ({
    type: types.SOLICITACAO_SET_COMBOBOXCCM,
    payload: { itensCombobox, cnpjCpf }
  }),
  disableTipoSolicitacao: data => ({
    type: types.DESABILITADO_TIPOSOLICITACAO,
    payload: data
  }),
  setReducerCcmDisabled: data => ({
    type: types.SET_REDUCER_CCM_DISABLED,
    payload: data
  }),
  setComboboxTipoSolicitacao: data => ({
    type: types.SET_TIPOSOLICITACAO,
    payload: data
  }),
  setCCMTipoSolicitacao: data => ({
    type: types.SET_CCMTIPOSOLICITACAO,
    payload: data
  }),
  resetForm: (
    ccm,
    TipoSolicitacao,
    resetTotal,
    cnpjCpf,
    disabledTipoSolicitacao
  ) => ({
    type: types.RESET_FORM,
    payload: {
      ccm,
      TipoSolicitacao,
      resetTotal,
      cnpjCpf,
      disabledTipoSolicitacao
    }
  }),
  setCpfCnpjSolicitacao: data => ({
    type: types.SOLICITACAO_SET_CPFCNPJ,
    payload: data
  }),
  setTipoSolicitacaoAtual: data => ({
    type: types.SET_TIPOSOLICITACAO_ATUAL,
    payload: data
  }),
  setDescricaoSolicitacao: data => ({
    type: types.SET_DESCRICAO_SOLICITACAO,
    payload: data
  }),
  setCCM: data => ({
    type: types.SET_CCM,
    payload: data
  })
};
